import type { Adaptors } from '@reactvideoeditor/react-video-editor/types';
import { createAspectlyLocalMediaAdaptor } from '@/rve/aspectlyLocalMediaAdaptor';
import { createAspectlyFreesoundAudioAdaptor } from '@/rve/aspectlyFreesoundAudioAdaptor';
import {
  createAspectlyPexelsImageAdaptor,
  createAspectlyPexelsVideoAdaptor,
} from '@/rve/aspectlyPexelsAdaptors';
import { createAspectlyQrStickerAdaptor } from '@/rve/aspectlyQrStickerAdaptor';

/** Wire My Library + Pexels + Freesound stock + QR sticker for Neo (D14: creative org). */
export function createAspectlyNeoAdaptors(orgId: number): Adaptors {
  return {
    localMedia: createAspectlyLocalMediaAdaptor(orgId),
    images: [createAspectlyPexelsImageAdaptor(orgId)],
    video: [createAspectlyPexelsVideoAdaptor(orgId)],
    audio: [createAspectlyFreesoundAudioAdaptor(orgId)],
    stickers: [createAspectlyQrStickerAdaptor()],
  };
}
